<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import ShapeType from './ShapeType.vue';
import ShapeInputs from '@/components/ShapeInputs.vue';

const store = useStore();
const selectedMenuItem = computed(() => store.getters.selectedMenuItem);
const shape = computed(() => store.getters.shape);

</script>
<template>
	<div class="shape-settings">
		<ShapeType
			v-if="selectedMenuItem === 'shapes'"
			:disabledShapes="['dxf', 'text', 'rectangle']"
			:storeShapeGetter="'shape'"
			:storeShapeUpdater="'updatePlateShape'"
		/>

		<shape-inputs v-if="shape !== ''" />
	</div>
</template>
<style scoped lang="scss">
	.shape-settings {
		display: flex;
		flex-direction: column;
		gap: 16px;
		border-radius: 8px;
		padding: 20px;
		background-color: $brand-blue-background;
	}
</style>
